import React from 'react';
import FieldRow from './FieldRow';
import { Textarea } from '../Inputs';
import { TextareaFieldProps } from './types';

export default function TextareaField({ onChange, inputStyles, ...props }) {
    return (
        <FieldRow {...props}>
            {({ field: { name, value, ...field }, form: { errors, touched, setFieldValue } }) => (
                <Textarea
                    name={name}
                    value={value}
                    {...field}
                    style={inputStyles}
                    hasError={errors[name] && touched[name]}
                    onChange={
                        onChange ||
                        ((e) => {
                            setFieldValue(name, e.target.value, false);
                        })
                    }
                />
            )}
        </FieldRow>
    );
}

TextareaField.propTypes = TextareaFieldProps;
